// import logo from './logo.svg';
import './App.css';
import { Helmet } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ProjectListPage from './pages/project/ProjectListPage';
import ProjectViewerPage from './pages/project/ProjectViewerPage';
import ConveyorListPage from './pages/conveyor/ConveyorListPage';
// import ProjectTemplate from './components/common/ProjectTemplate';
import TowerListPage from './pages/tower/TowerListPage';
// import WeightSummaryPage from './pages/summary/WeightSummaryPage';
import ConveyorViewerPage from './pages/conveyor/ConveyorViewerPage';
import ConveyorWritePage from './pages/conveyor/ConveyorWritePage';
import ProjectWritePage from './pages/project/ProjectWritePage';
import TowerWritePage from './pages/tower/TowerWritePage';
import StructureListPage from './pages/structure/StructureListPage';
import StructureEstimatePage from './pages/structure/StructureEstimatePage';
import ComponentListPage from './pages/component/ComponentListPage';
import AccessoryListPage from './pages/accessory/AccessoryListPage';
import StatisticsPage from './pages/statistics/StatisticsPage';
import PulleyListPage from './pages/pulley/PulleyListPage';
import PulleyWritePage from './pages/pulley/PulleyWritePage';


function App() {
    return (
        <>
            <Helmet>
                <title>Quantity Estimation</title>
            </Helmet>
            <Routes>
                <Route path="/" element={<ProjectListPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                {/* 프로젝트 */}
                <Route path="/projects" element={<ProjectListPage />} />
                <Route path="/write/project" element={<ProjectWritePage />} />
                <Route path="/projects/:projectId">
                    <Route index element={<ProjectViewerPage />} />
                    <Route path="overview" element={<ProjectViewerPage />} />
                    <Route path="conveyors" element={<ConveyorListPage />} />
                    <Route path="component" element={<ComponentListPage />} />
                    <Route path="pulley" element={<PulleyListPage />} />
                    <Route path="structure" element={<StructureListPage />} />
                    <Route path="towers" element={<TowerListPage />} />
                    <Route path="accessories" element={<AccessoryListPage />} />
                    <Route path="statistics" element={<StatisticsPage />} />
                </Route>
                {/* 컨베이어 */}
                <Route path="conveyors" element={<ConveyorListPage />} />
                <Route path="conveyors/:conveyorId" element={<ConveyorViewerPage />} />
                <Route path="write/conveyor" element={<ConveyorWritePage />} />
                {/* Structure */}
                <Route path="/write/structure" element={<StructureEstimatePage />} />
                {/* 타워 */}
                <Route path="/write/tower" element={<TowerWritePage />} />
                풀리
                <Route path="/write/pulley" element={<PulleyWritePage />} />
            </Routes>
        </>
    );
}

export default App;
